import { ReduxState } from "~/types/redux";
import { Address, AddressAllconnect, AddressCookiePass } from "../types/address";

const addressFormatter = (address: string, address2?: string): string => {
  if (address && address2) {
    return `${address} - ${address2}`;
  }

  return address;
};

export const addressFormatCookiePass = (address): AddressCookiePass => {
  const addr = {
    addressKey: address?.addressKey || "",
    addressLine1: address?.street_line,
    addressLine2: address?.secondary || "",
    city: address?.city || "",
    stateProvince: address?.state || "",
    zipCode: address?.zip || "",
    zipCode4: address?.zip4 || "",
    latitude: address?.point?.latitude || "",
    longitude: address?.point?.longitude || "",
    parsedAddress: {
      streetName: "",
      streetNumber: address?.primary || "",
      streetPostDirectional: address?.postDirection || "",
      streetPreDirectional: address?.preDirection || "",
      streetSuffix: "",
    },
    rawUserString: "",
    isParent: false,
    parentKey: "",
    inFootprint: true, // TODO: 4/30/25 - Beth - Set to true for now.  Revisit to align with Exhaustive Experience implementation.
  };

  addr.rawUserString = `${addr.addressLine1},${addr.addressLine2},${addr.city},${addr.stateProvince},${addr.stateProvince}`;
  return addr;
};

export const addressFormatAllconnect = (address: AddressAllconnect): Address => {
  const addr: Address = {
    address: address?.street_line,
    address2: address?.secondary || "",
    city: address?.city || "",
    state: address?.state || "",
    zip: address?.zip || "",
    zip4: address?.zip4 || "",
    latitude: address?.point?.latitude || 0,
    longitude: address?.point?.longitude || 0,
    parsedAddress: {
      streetName: "",
      streetNumber: address?.primary || "",
      streetPostDirectional: address?.postDirection || "",
      streetPreDirectional: address?.preDirection || "",
      streetSuffix: "",
    },
    rawUserInput: address?.prettyAddress || "",
    isParent: false,
    parentKey: "",
    inFootprint: true, // TODO: 4/30/25 - Beth - Set to true for now.  Revisit to align with Exhaustive Experience implementation.
  };

  if (!addr.rawUserInput) {
    addr.rawUserInput = `${addr.address},${addr.address2},${addr.city},${addr.state},${addr.zip}`;
  }

  return addr;
};

export const generateAllConnectAddressQueryParams = (
  address: ReduxState["address"],
  csid?: ReduxState["tracking"]["clientSessionId"]
): string => {
  const streetName = address?.install?.parsedAddress?.streetName ?? "";
  const streetSuffix = address?.install?.parsedAddress?.streetSuffix ?? "";
  const params = {
    street_line: address?.install?.address ?? "",
    primary: address?.install?.parsedAddress?.streetNumber ?? "",
    secondary: address?.install?.address2 ?? "",
    postDirection: address?.install?.parsedAddress?.streetPostDirectional ?? "",
    preDirection: address?.install?.parsedAddress?.streetPreDirectional ?? "",
    street: `${streetName} ${streetSuffix}`,
    city: address?.install?.city ?? "",
    state: address?.install?.state ?? "",
    zip: address?.install?.zip ?? "",
    point: JSON.stringify({
      latitude: address?.install?.latitude ?? "",
      longitude: address?.install?.longitude ?? "",
    }),
    ...(csid && { parent_session: csid ?? "" }),
  };
  if (address?.install?.zip4) params.zip = `${address?.install?.zip}-${address?.install?.zip4}`;

  const paramsString = Object.keys(params)
    .map((key) => key + "=" + encodeURIComponent(params[key]))
    .join("&");

  return paramsString;
};

export const generateRedirectProviderAddressQueryParams = (
  address: ReduxState["address"],
  csid?: ReduxState["tracking"]["clientSessionId"]
): string => {
  const params = {
    "ptv[street_line]": address?.install?.address ?? "",
    "ptv[city]": address?.install?.city ?? "",
    "ptv[state]": address?.install?.state ?? "",
    "ptv[zip]": address?.install?.zip ?? "",
    "ptv[parent_session]": csid ?? "",
    sub_id: "{click_id}",
  };
  if (address?.install?.zip4) params["ptv[zip]"] = `${address?.install?.zip}-${address?.install?.zip4}`;

  const paramsString = Object.keys(params)
    .map((key) => key + "=" + encodeURIComponent(params[key]))
    .join("&");

  return paramsString;
};

export default addressFormatter;
